const axios = require("axios");

export const diagnosis = async (age, sex, evidence) => {
    return await send("POST", "diagnosis", {age, sex, evidence});
};

export const triage = async (age, sex, evidence) => {
    return await send("POST", "triage", {age, sex, evidence});
};

const APP_ID = '7f78bb6b';
const APP_KEY = 'c5dc3bb17c91cbbc9667474b7672af9f';

const send = async (method, endpoint, data) => {
    const response = await axios.request({
        url: `https://api.infermedica.com/covid19/${endpoint}`,
        headers: {
            "Content-Type": "application/json",
            "App-Id": APP_ID,
            "App-Key": APP_KEY,
        },
        method,
        data,
    });
    return response.data;
};
